import React, { useState, useContext } from "react";
import { useLocation, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Preloader from "./../Preloader";
import useBreadcrumbs from "./../useBreadcrumbs";
import { SubscribeContext } from "../SubscribeContext";

const Layout = ({ children, headers, isLoading }) => {
  const [subscribeOpen, setSubscribeOpen] = useState(false);
  const [modalState, setModalState] = useState("form");

  const openSubscribe = () => {
    setSubscribeOpen(true);
    setModalState("form");
  };

  const location = useLocation();

  // SAFE BREADCRUMBS
  const breadcrumbData = useBreadcrumbs();

  const breadcrumbs = Array.isArray(breadcrumbData)
    ? breadcrumbData.filter(
        (item) =>
          item &&
          typeof item === "object" &&
          typeof item.label !== "object"
      )
    : [];

  const showBreadcrumbs =
    location.pathname !== "/" && breadcrumbs.length > 0;

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <SubscribeContext.Provider value={{ openSubscribe }}>
          <Header headers={headers} />

          <main
            id="mainContent"
            style={{
              maxWidth: "var(--max-width)",
              margin: "18px auto 0",
              padding: "0 20px",
            }}
          >
            {showBreadcrumbs && (
              <nav
                className="breadcrumb"
                role="navigation"
                aria-label="Breadcrumbs"
                style={{
                  marginBottom: "20px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  alignItems: "center",
                }}
              >
                {breadcrumbs.map((item, index) => (
                  <React.Fragment key={index}>
                    {item?.link ? (
                      <span className="breadcrumb-label">
                        <Link to={item.link}>
                          {String(item.label)}
                        </Link>
                      </span>
                    ) : (
                      <span
                        className="breadcrumb-label"
                        style={{ color: "#6b7785" }}
                      >
                        {String(item.label)}
                      </span>
                    )}

                    {index < breadcrumbs.length - 1 && (
                      <span
                        className="breadcrumb-separator"
                        aria-hidden="true"
                      >
                        &gt;
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </nav>
            )}

            <article>{children}</article>
          </main>

          <Footer
            isModalOpen={subscribeOpen}
            setIsModalOpen={setSubscribeOpen}
            modalState={modalState}
            setModalState={setModalState}
          />
        </SubscribeContext.Provider>
      )}
    </>
  );
};

export default Layout;